import { render, staticRenderFns } from "./AssigneeCombo.vue?vue&type=template&id=b43bcc90&"
import script from "./AssigneeCombo.vue?vue&type=script&lang=ts&"
export * from "./AssigneeCombo.vue?vue&type=script&lang=ts&"
import style0 from "./AssigneeCombo.vue?vue&type=style&index=0&id=b43bcc90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports